import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InputType } from '@voyagu/portal-design-system';

import { DsFormlyFieldType } from '@app/forms/formly/types/ds-formly-field';

@Component({
  selector: 'input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputFieldComponent extends DsFormlyFieldType {
  get inputType(): InputType {
    const type = this.props.type;

    if (type === 'email' || type === 'password' || type === 'tel' || type === 'number') {
      return type;
    }

    return 'text';
  }

  get autocomplete(): string | undefined {
    const value = this.props.attributes?.['autocomplete'];
    return typeof value === 'string' ? value : undefined;
  }
}
